import { render, staticRenderFns } from "./ReferenciasInstitucional.vue?vue&type=template&id=e9689e5a&"
import script from "./ReferenciasInstitucional.vue?vue&type=script&lang=js&"
export * from "./ReferenciasInstitucional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports